import { ApiKey, darkThemeStyles } from '@jupiterone/jupiter-web-toolkit';
import { Table, TableBody } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import ApiKeyRow from './ApiKeyRow';
import ApiKeysTableHeader from './ApiKeysTableHeader';

const useStyles = makeStyles(darkThemeStyles);

interface Props {
  className?: string;
  apiKeys: ApiKey[];
  onDeleteClick: (index: number) => void;
}

const ApiKeysTable = ({ className, apiKeys, onDeleteClick }: Props) => {
  const classes = useStyles();

  const handleDeleteClick = (index: number) => () => {
    onDeleteClick(index);
  };

  return (
    <Table className={className}>
      <ApiKeysTableHeader />
      <TableBody className={classes.tableBody}>
        {apiKeys.map((apiKey: ApiKey, index: number) => (
          <ApiKeyRow
            key={apiKey.id}
            apiKey={apiKey}
            onDeleteClick={handleDeleteClick(index)}
          />
        ))}
      </TableBody>
    </Table>
  );
};

export default ApiKeysTable;
